import React from "react";

const Footer = () => {
  return <footer className="footer-wrapper">Hongirana Interiors</footer>;
};

export default Footer;
